var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gameplay-hints"},[_c('p',{staticClass:"text3"},[_vm._v("Hints")]),_vm._l((3),function(index){return _c('SiestaHint',{key:index,attrs:{"index":index},on:{"showHint":_vm.showHint}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }